import { apiFetch } from '@/lib/api-client';
import type { Child, CreateChildRequest } from '@/lib/auth-types';

/**
 * API client for the Phase 1E backend children CRUD endpoints. All
 * endpoints are JwtAuthGuard + EmailVerifiedGuard + owner-scoped.
 *
 * The backend enforces `MAX_CHILDREN_PER_ACCOUNT` (SystemConfig,
 * default 10) on `createChild`. PWA does not pre-check — surface the
 * 400 from the backend if a user hits the cap.
 */

export function listChildren(): Promise<Child[]> {
  return apiFetch<Child[]>('/api/children', { method: 'GET' });
}

export function getChild(id: string): Promise<Child> {
  return apiFetch<Child>(`/api/children/${id}`, { method: 'GET' });
}

export function createChild(payload: CreateChildRequest): Promise<Child> {
  return apiFetch<Child>('/api/children', {
    method: 'POST',
    body: payload,
  });
}

export function updateChild(id: string, patch: Partial<CreateChildRequest>): Promise<Child> {
  return apiFetch<Child>(`/api/children/${id}`, {
    method: 'PATCH',
    body: patch,
  });
}

export function deleteChild(id: string): Promise<{ message: string }> {
  return apiFetch<{ message: string }>(`/api/children/${id}`, {
    method: 'DELETE',
  });
}
